module.exports = __webpack_public_path__ + "static/media/playstore.686503a3.svg";